import { Layout } from "../components/Layout";
import { Card } from "../components/ui/card";
import { useNavigate } from "react-router-dom";

const RandomCoffee = () => {
  const navigate = useNavigate();

  return (
    <Layout
      showBackButton
      onBack={() => navigate(-1)}
      className="flex flex-col h-full"
    >
      <Card className="border-none bg-white text-black shadow-lg p-4">
        Мы запустим случайные встречи между выпускниками как только в Сообществе
        зарегистрируется достаточное количество участников
      </Card>
    </Layout>
  );
};

export default RandomCoffee;
